import React from 'react'
import { Avatar, CardHeader, Box, Typography } from '@mui/material'
import { ChatContext } from '../../../contexts/ChatContext'
import { BsCheckAll } from 'react-icons/bs'
import moment from 'moment'

import stylesC from './styles'

export default function CompChat({ chat, onClick, fotoEmpresa }) {
  const { sttChatCtx } = React.useContext(ChatContext)

  const naoLida = (chat.ultimaMensagem?.status === 'ENVIADA' && chat.ultimaMensagem?.criadaPorAdmin) || false

  function ReturnString(texto) {
    const TAMANHO = 20
    if (texto.length > TAMANHO) {
      return texto.substring(0, TAMANHO) + '...'
    }
    return texto
  }

  function ReturnEnviado(chat) {
    if (!chat.ultimaMensagem?.criadaPorAdmin) {
      if (chat.ultimaMensagem) {
        return (
          <Box sx={stylesC.containLabel}>
            <BsCheckAll size={20} color={chat.ultimaMensagem.status === 'LIDA' ? '#6c6cff' : 'gray'} />
            <Typography variant='h6' sx={{ ...stylesC.labelComp, fontSize: '11px' }}>{`Enviada ${moment(
              chat.ultimaMensagem.createdAt,
            ).fromNow()}`}</Typography>
          </Box>
        )
      } else {
        return (
          <Typography variant='h6' sx={{ ...stylesC.labelComp, fontSize: '11px' }}>
            Enviada
          </Typography>
        )
      }
    } else {
      return (
        <Typography variant='h6' sx={{ ...stylesC.labelComp, fontSize: '11px' }}>
          {chat.ultimaMensagem ? `Recebida ${moment(chat.ultimaMensagem.createdAt).fromNow()}` : ''}
        </Typography>
      )
    }
  }

  function ReturnStatusPedido(status) {
    switch (status) {
      case 'SOLICITADO':
        return <Typography sx={{ ...stylesC.labelComp, color: '#ff7043', fontWeight: 'bold' }}>{status}</Typography>
      case 'AGENDADO':
        return <Typography sx={{ ...stylesC.labelComp, color: '#22ac4a', fontWeight: 'bold' }}>{status}</Typography>
      case 'REALIZADO':
        return <Typography sx={{ ...stylesC.labelComp, color: '#00cda4', fontWeight: 'bold' }}>{status}</Typography>
      case 'CANCELADO':
        return <Typography sx={{ ...stylesC.labelComp, color: '#bf3324', fontWeight: 'bold' }}>{status}</Typography>
    }
  }

  return (
    <Box
      onClick={onClick}
      sx={sttChatCtx.chat?.idchat === chat.idchat ? stylesC.containChatSel : naoLida ? stylesC.containChatMNL : stylesC.containChat}
    >
      <CardHeader
        sx={stylesC.containHeader}
        avatar={<Avatar sx={stylesC.containAvatar} src={fotoEmpresa} alt={chat.nomeEmpresa} />}
        title={<Typography sx={stylesC.titleComp}>{chat.nomeEmpresa}</Typography>}
        subheader={
          <Box>
            <Typography sx={stylesC.labelComp}>{ReturnString(chat.ultimaMensagem?.texto || '')}</Typography>
            {ReturnEnviado(chat)}
          </Box>
        }
      />
      {chat.pedido.dataInicio && (
        <Box
          sx={{
            ...stylesC.containPedido,
            border: sttChatCtx.chat?.idchat === chat.idchat ? '1px solid #ff7043' : '1px solid #d9d9d9',
          }}
        >
          <Typography sx={stylesC.labelComPedido}>{`${moment(chat.pedido.dataInicio).format('hh:mm')} às ${moment(chat.pedido.dataFinal).format(
            'hh:mm',
          )}`}</Typography>
          <Typography sx={{ ...stylesC.labelComp, fontSize: '12px', whiteSpace: 'nowrap' }}>
            {moment(chat.pedido.dataInicio).format('ddd, DD/MM/YYYY')}
          </Typography>
          {ReturnStatusPedido(chat.pedido.status)}
        </Box>
      )}
    </Box>
  )
}
